export default {
	"transportOrderInfoOfTransportPlan": {
		"changeTime": "时间修改"
	},
	"transportPlan": {
		"askCompleteTime": "要求完成时间"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/transportPlan/transportPlan.js